import { useCallback } from 'react'

import analytics from 'legacy/utils/analytics'

import { useShipmentAnalyticsContext } from '../ShipmentAnalyticsContext'

export function useShipmentAnalytics() {
  const properties = useShipmentAnalyticsContext()

  const track = useCallback(
    (eventName: string, payload = {}) => {
      analytics.track(eventName, {
        ...properties,
        ...payload,
      })
    },
    [properties]
  )

  return { track }
}
